(function () {
  "use strict";

  function initializeCountdown(portal, cleanups) {
    var countdown = portal.querySelector("[data-drip-crypt-countdown]");
    if (!countdown) return;

    var target = Date.parse(portal.getAttribute("data-public-drop") || "");
    if (!Number.isFinite(target) || target <= Date.now()) {
      countdown.hidden = true;
      return;
    }

    var fields = {
      days: countdown.querySelector('[data-countdown="days"]'),
      hours: countdown.querySelector('[data-countdown="hours"]'),
      minutes: countdown.querySelector('[data-countdown="minutes"]'),
      seconds: countdown.querySelector('[data-countdown="seconds"]')
    };
    var pad = function (value) {
      return String(value).padStart(2, "0");
    };
    var timer = 0;
    var update = function () {
      var remaining = Math.max(0, target - Date.now());
      var totalSeconds = Math.floor(remaining / 1000);
      var values = {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor((totalSeconds % 86400) / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60
      };

      Object.keys(values).forEach(function (key) {
        if (fields[key]) fields[key].textContent = pad(values[key]);
      });

      if (remaining === 0) {
        countdown.hidden = true;
        if (timer) window.clearInterval(timer);
      }
    };

    update();
    countdown.classList.remove("is-pending");
    countdown.setAttribute("aria-hidden", "false");
    timer = window.setInterval(update, 1000);
    cleanups.push(function () {
      if (timer) window.clearInterval(timer);
    });
  }

  function initializeMobileForms(portal, cleanups) {
    portal.querySelectorAll("[data-drip-crypt-mobile-form]").forEach(function (host) {
      if (host.getAttribute("data-drip-crypt-mobile-ready") === "true") return;
      host.setAttribute("data-drip-crypt-mobile-ready", "true");
      var form = host.querySelector("[data-drip-crypt-mobile-klaviyo]");
      if (!form) return;
      var handoff = host.querySelector("[data-drip-crypt-sms-handoff]");
      var fallback = host.querySelector(".drip-crypt__mobile-sms-fallback");
      var formId = host.getAttribute("data-drip-crypt-mobile-form-id");
      var observer;

      // Use the same iOS Messages URL convention as the homepage signup.
      if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
        host.querySelectorAll('a[href^="sms:"]').forEach(function (link) {
          link.href = link.getAttribute("href").replace("?body=", "&body=");
        });
      }

      var showHandoff = function () {
        if (!handoff || host.classList.contains("is-sms-handoff")) return;
        // A tap opens Messages. Only sending the text can complete SMS consent.
        host.classList.add("is-sms-handoff");
        handoff.hidden = false;
        if (observer) observer.disconnect();
        handoff.focus({ preventScroll: true });
      };
      var onFormEvent = function (event) {
        var detail = event.detail || {};
        if (detail.formId === formId && detail.type === "stepSubmit") showHandoff();
      };
      window.addEventListener("klaviyoForms", onFormEvent);
      if (fallback) fallback.addEventListener("click", showHandoff);
      cleanups.push(function () {
        window.removeEventListener("klaviyoForms", onFormEvent);
        if (fallback) fallback.removeEventListener("click", showHandoff);
      });

      var sync = function () {
        // Klaviyo owns the signup action. The theme retains the Messages handoff
        // because tap to text can close and unmount the embedded form.
        if (host.classList.contains("has-klaviyo-form") || host.classList.contains("is-sms-handoff")) return;
        var renderedControl = form.querySelector("a[href^='sms:'], button.klaviyo-form-button:not(:disabled):not([aria-disabled='true'])");
        var disclosure = form.querySelector(".klaviyo-disclosure");
        if (host.contains(document.activeElement) && !form.contains(document.activeElement)) return;
        if (!renderedControl || !disclosure) return;
        host.classList.add("has-klaviyo-form");
        if (observer) observer.disconnect();
      };

      if (typeof MutationObserver === "function") {
        observer = new MutationObserver(sync);
        observer.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'href'] });
        cleanups.push(function () {
          observer.disconnect();
        });
      }
      sync();
    });
  }

  function initializeDesktopForms(portal, cleanups) {
    portal.querySelectorAll('[data-drip-crypt-desktop-form]').forEach(function (host) {
      var form = host.querySelector('[data-drip-crypt-desktop-klaviyo]');
      var sync = function () {
        // Once handed over, Klaviyo retains ownership of validation and success.
        if (!form.querySelector('input[type="tel"]:not(:disabled)')) return;
        host.classList.add('has-klaviyo-form');
        observer.disconnect();
      };
      var observer = new MutationObserver(sync);
      observer.observe(form, { childList: true, subtree: true });
      sync();
      cleanups.push(function () { observer.disconnect(); });
    });
  }

  function initializePasscodeToggle(portal, cleanups) {
    var toggle = portal.querySelector("[data-drip-crypt-toggle]");
    if (!toggle) return;

    var updateLabel = function () {
      window.requestAnimationFrame(function () {
        toggle.textContent = toggle.getAttribute("aria-pressed") === "true" ? "HIDE" : "SHOW";
      });
    };
    toggle.addEventListener("click", updateLabel);
    cleanups.push(function () {
      toggle.removeEventListener("click", updateLabel);
    });
  }

  function initialize() {
    document.querySelectorAll("[data-drip-crypt]").forEach(function (portal) {
      if (portal.getAttribute("data-drip-crypt-refresh-ready") === "true") return;
      portal.setAttribute("data-drip-crypt-refresh-ready", "true");
      var cleanups = [];
      portal.dripCryptRefreshCleanup = function () {
        cleanups.forEach(function (cleanup) {
          cleanup();
        });
      };
      initializeCountdown(portal, cleanups);
      initializeMobileForms(portal, cleanups);
      initializeDesktopForms(portal, cleanups);
      initializePasscodeToggle(portal, cleanups);
    });
  }

  function unload(event) {
    var portal = event.target.matches("[data-drip-crypt]")
      ? event.target
      : event.target.querySelector("[data-drip-crypt]");
    if (portal && typeof portal.dripCryptRefreshCleanup === "function") {
      portal.dripCryptRefreshCleanup();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    initialize();
  }

  document.addEventListener("shopify:section:load", initialize);
  document.addEventListener("shopify:section:unload", unload);
}());
